(function () {
	const swiperInstances = new Map();

	const initTabsWithProducts = () => {
		const tabsParent = $(".tabs-with-text");
		const tabs = tabsParent.find(".twt__tabs-item");

		tabs.off("click").on("click", function () {
			const tabsContent = $(this)
				.closest(".twt__tabs")
				.next()
				.find(".twt__content-item");

			const mediaItems = $(this)
				.closest(".tabs-with-text")
				.find(".twt__media_item");

			if (!$(this).is("[data-active]")) {
				$(this).parent().find("[data-active]").removeAttr("data-active");
				$(this).attr("data-active", "");

				const idx = $(this).index();

				tabsContent.hide().eq(idx).fadeIn(0).css("display", "flex");

                const mediaSwiperEl = $(this).closest(".tabs-with-text").find(".twt__media.swiper")[0];
                if (mediaSwiperEl && mediaSwiperEl.swiper) {
                  mediaSwiperEl.swiper.slideTo(idx);
                }
			}
		});

		tabsParent.each(function (_, elem) {
			const tabsSlider = elem.querySelector(".twt__tabs");
			const tabsPrev = elem.querySelector(".twt__prev");
			const tabsNext = elem.querySelector(".twt__next");
			const isMobile = window.innerWidth < 750;
			const swiper = swiperInstances.get(tabsSlider);

			if (isMobile && !swiper) {
				const instance = new Swiper(tabsSlider, {
                  slidesPerView: "auto",
                  slidesPerGroup: 1,
                  allowTouchMove: false,
                  centeredSlides: false,
                  freeMode: false, 
                  navigation: {
                    nextEl: tabsNext,
                    prevEl: tabsPrev,
                  }
                });
				swiperInstances.set(tabsSlider, instance);
			} else if (!isMobile && swiper) {
				swiper.destroy(true, true);
				swiperInstances.delete(tabsSlider);
			}

            const mediaSwiperEl = elem.querySelector('.twt__media.swiper');

            if (mediaSwiperEl && !mediaSwiperEl.swiper) {
              new Swiper(mediaSwiperEl, {
                slidesPerView: 1,
                allowTouchMove: true,
                autoHeight: true,
                on: {
                  slideChange: function () {
                    const idx = this.activeIndex;
                
                    $(tabs).removeAttr("data-active");
                    $(tabs[idx]).attr("data-active", "");
                
                    const tabsContent = $(elem).find(".twt__content-item");
                    tabsContent.hide().eq(idx).fadeIn(0).css("display", "flex");
                
                    const tabSwiperEl = elem.querySelector(".twt__tabs");
                    const tabSwiper = swiperInstances.get(tabSwiperEl);
                    
                    if (tabSwiper) {
                      tabSwiper.slideTo(idx); // snap active tab to the left
                    }
                  }
                }
              });
            }
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.tabs-with-text');

		let resizeTimeout;
        const resizeHandler = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(initTabsWithProducts, 200);
        };

		initTabsWithProducts();

		window.addEventListener('resize', resizeHandler);
		document.addEventListener("shopify:section:unload", () => {
            clearTimeout(resizeTimeout);
			window.removeEventListener('resize', resizeHandler);
		});
	};

	initSection();

	document.addEventListener("shopify:section:load", function () {
		initSection();
	});
})();
